import { render, staticRenderFns } from "./viewFeedBack.vue?vue&type=template&id=04497d9f&scoped=true&"
import script from "./viewFeedBack.vue?vue&type=script&lang=js&"
export * from "./viewFeedBack.vue?vue&type=script&lang=js&"
import style0 from "./viewFeedBack.vue?vue&type=style&index=0&id=04497d9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04497d9f",
  null
  
)

export default component.exports